<script src>
import { ref, toValue, defineComponent, h } from "vue";

export default defineComponent({
	setup(props, { slots }) {

		console.log('slots', slots)

		const toggleExpanded = () => {
			expanded.value = !toValue(expanded)
		}

		const expanded = ref(false)

		return () => h('div', {
			onClick: () => { toggleExpanded() },
			class: ['faq', toValue(expanded) ? 'faq--expanded' : '']
		}, [
			h('div', { class: 'faq__title' }, [
				slots.default()
			]),
			h('div', { class: 'faq__content' }, [
				slots.content()
			])
		])
	}
});

</script>